import api from "./api";

const userService = {
    changePassword: (jwttoken, currentPassword, newPassword) =>
        api.post(`/users/changePassword`, {
            currentPassword,
            newPassword
        }, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
};

export default userService;